import { atom, selector } from "recoil";

export const clientAddressState = atom({
  key: "clientAddressState",
  default: [],
});

export const addressSelectState = selector({
  key: "FilteredTodoList",
  get: ({ get }) => {
    const data = get(clientAddressState);

    const newData = [
      ...data.map((item, index) => ({
        label: item?.city ?? `unKnown address - ${index}`,
        value: item?.id,
        type: item?.type,
      })),
      {
        label: "add new address",
        value: "add _new_address",
        type: null,
      },
    ];
    return newData;
  },
});
